// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Xt_UI","content":"styles_content__3ZNLU","selectAll":"styles_selectAll__1xKX7"};